(() => {
  const navigationSelector = '.homepage-navigation';
  const initializedNavigations = new WeakSet();

  class HomepageHeroPreview {
    constructor(navigation) {
      this.navigation = navigation;
      this.links = Array.from(navigation.querySelectorAll('[data-homepage-hero-image]'));
      this.preview = document.querySelector('[data-homepage-hero-preview]');
      this.layers = Array.from(this.preview?.querySelectorAll('[data-homepage-hero-preview-image]') || []);
      this.activeLayer = -1;
      this.requestedUrl = '';
      this.hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

      if (!this.links.length || this.layers.length !== 2) return;

      this.preload();
      this.bindEvents();
    }

    preload() {
      this.links.forEach((link) => {
        const image = new Image();
        image.src = link.dataset.homepageHeroImage;
      });
    }

    bindEvents() {
      this.links.forEach((link) => {
        link.addEventListener('mouseenter', () => {
          if (this.hoverCapable.matches) this.show(link.dataset.homepageHeroImage, link.dataset.homepageHeroPosition, link.dataset.homepageHeroRotation);
        });
        link.addEventListener('focus', () => this.show(link.dataset.homepageHeroImage, link.dataset.homepageHeroPosition, link.dataset.homepageHeroRotation));
      });

      this.navigation.addEventListener('mouseleave', () => {
        if (this.hoverCapable.matches) this.restore();
      });

      this.navigation.addEventListener('focusout', () => {
        window.requestAnimationFrame(() => {
          if (!this.navigation.contains(document.activeElement)) this.restore();
        });
      });
    }

    show(url, position = 'center center', rotation = '0deg') {
      if (!url || url === this.requestedUrl) return;
      this.requestedUrl = url;
      const nextIndex = this.activeLayer === 0 ? 1 : 0;
      const nextLayer = this.layers[nextIndex];
      nextLayer.style.objectPosition = position;
      nextLayer.style.transform = rotation === '0deg' ? '' : `scale(1.04) rotate(${rotation})`;

      const reveal = () => {
        if (this.requestedUrl !== url) return;
        this.layers.forEach((layer, index) => layer.classList.toggle('is-active', index === nextIndex));
        this.activeLayer = nextIndex;
      };

      nextLayer.src = url;
      nextLayer.complete ? reveal() : nextLayer.addEventListener('load', reveal, { once: true });
    }

    restore() {
      this.requestedUrl = '';
      this.layers.forEach((layer) => layer.classList.remove('is-active'));
      this.activeLayer = -1;
    }
  }

  const initialize = (scope = document) => {
    const navigations = scope.matches?.(navigationSelector)
      ? [scope]
      : Array.from(scope.querySelectorAll(navigationSelector));

    navigations.forEach((navigation) => {
      if (initializedNavigations.has(navigation)) return;
      initializedNavigations.add(navigation);
      new HomepageHeroPreview(navigation);
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
